import { useState } from 'react'
import InputFormCard from '@component/InputFormCard'
import UnitAdornment from '@component/UnitAdornment'
import { TextField } from '@mui/material'
import { useHistoryList } from '@component/HistoryList'
import { useTranslation } from 'react-i18next'
import { Query } from '@core/query'
import { Controller } from 'react-hook-form'
import { makeFormRules, toMillimeter } from '@/utils'
import { useTwoWaySlab } from './context'

function TwoWaySlabForm () {
  const { t } = useTranslation()

  const { form, setResult } = useTwoWaySlab()
  const { appendHistory } = useHistoryList()

  const {
    control,
    reset,
    handleSubmit,
  } = form

  const rules = makeFormRules()

  const [isLoading, setLoading] = useState(false)
  const onSubmit = handleSubmit(async _ => {
    if (_.longSideSpan <= 0 || _.shortSideSpan <= 0) {
      alert(t('SENTENCE.CHECK_YOUR_INPUT'))
      return
    }

    setLoading(true)
    const res = await Query.requestCalcTwoWaySlab(_)
    setLoading(false)

    const needThickness = toMillimeter(res.needThickness)
    setResult(needThickness)
    appendHistory({
      type: 'TwoWaySlab',
      ..._,
      result: needThickness,
    })
  })

  const onReset = () => {
    reset()
    setResult(null)
  }

  return (
    <InputFormCard
      title={t('GLOSSARY.TWO_WAY_SLAB')}
      onReset={onReset}
      onSubmit={onSubmit}
      loading={isLoading}
    >
      <Controller
        name="longSideSpan"
        control={control}
        rules={rules}
        render={({ field, fieldState }) => (
          <TextField
            label={t('GLOSSARY.LONGSIDE_SPAN')}
            InputProps={{
              endAdornment: <UnitAdornment unit="m" />,
            }}
            {...field}
            error={fieldState.invalid}
          />
        )}
      />
      <Controller
        name="shortSideSpan"
        control={control}
        rules={rules}
        render={({ field, fieldState }) => (
          <TextField
            label={t('GLOSSARY.SHORTSIDE_SPAN')}
            InputProps={{
              endAdornment: <UnitAdornment unit="m" />,
            }}
            {...field}
            error={fieldState.invalid}
          />
        )}
      />
    </InputFormCard>
  )
}

export default TwoWaySlabForm
